import { ReactComponent as LoaderSvg } from 'src/assets/icons/loader.svg';
import styled from 'styled-components';

export const LoaderIcon = styled(LoaderSvg)``;
